import { Directive, Host, Input, OnInit, Optional, TemplateRef } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { MOperationsTemplateService } from './operations-template.service';

@Directive({
  selector: '[m-ref]'
})
export class MOperationsDirective implements OnInit {
  @Input('m-ref') tplName = ''; // 获取定义的模版名

  constructor(private ref: TemplateRef<NzSafeAny>, @Host() @Optional() private templateService: MOperationsTemplateService) {}
  ngOnInit(): void {
    this.templateService.add(this.tplName, this.ref);
  }
}
